export default {
  id: {
    text: 'id',
    visible: true,
    sortable: true,
    hasLink: true,
  },
  name: {
    text: 'Name',
    visible: true,
    sortable: true,
    hasLink: true,
  },
  contacts_with_pending_tasks: {
    text: 'Active Contacts',
    visible: true,
    sortable: false,
    hasLink: true,
  },
  created_at: {
    text: 'Date Created',
    visible: true,
    sortable: true,
  },
  modified_at: {
    text: 'Date Modified',
    visible: true,
    sortable: true,
  },
  is_broker_sharing_on: {
    text: '',
    visible: true,
    sortable: false,
  },
  is_default: {
    text: 'Is Default',
    visible: false,
    sortable: false,
  },
  is_shared_by_broker: {
    text: 'Is Shared',
    visible: true,
    sortable: false,
  },
  id_drip_shared: {
    text: '',
    visible: true,
    sortable: false,
  },
};
